
import { WDFormDropdown } from './wd-form-dropdown';
import WDRes from '../../core/fetch/wd-res';

export class WDFormIcon extends WDFormDropdown
{

	constructor(opts)
	{
		opts.allowSearch = true;
		opts.templates = {
			value: '${class_name}',
			label: '<div><span class="${class_name}"></span>${name} - ${style.capitalize()}</div>',
		};

		super(opts);

		const url = window.location.origin + '/assets/vendor/wd-fontawesome/icons.json';

		WDRes.getJSON(url).then(icons => this.options = icons );

	};

};

customElements.define('wd-form-icon', WDFormIcon);
